import { styled } from "@mui/material";

export const InquiryWrapper = styled('div')({
    display: "flex",
    alignItems: "center",
    minHeight: "75vh",
    gap: "42px",
    justifyContent: "space-between"
});

export const InquiryLeft = styled('div')({
    display: "flex",
    flexDirection: "column",
    flex: 0.6,
    maxWidth: "594px"
});

export const InquiryRight = styled('div')({
    display: "flex",
    flex: 0.4
});
